<template>
  <div :class="video_popup_class">
    <div class="popup_video_container relative" v-if="!has_link">
      <div class="scroll-helper" @click="prevent_close($event)">
        <img :src="img_src" :style="img_style" />

        <div class="option-bar" @click.prevent="close_subpopup($event)">
          <span class="close-link">X</span>
        </div>
      </div>
    </div>
    <div class="relative" v-if="has_link">
      <div class="scroll-helper" @click="prevent_close($event)">
        <a :href="link_src" target="_blank"
          ><img :src="img_src" :style="img_style"
        /></a>
        <div class="option-bar" @click.prevent="close_subpopup($event)">
          <span class="close-link">X</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "sub_video",
  data() {
    return {
      loading: "loading"
    };
  },
  props: ["item"],
  computed: {
    ...mapState([
      "current_section",
      "current_sub_section",
      "current_secondary_section",
      "current_secondary_sub_section",
      "sections_content"
    ]),
    ...mapGetters(["eventTag"]),
    page_url() {
      var str = "/popups/video/" + this.$store.state.popup_video_src;
      if (this.$store.state.app_type == "mobile") {
        str = "/mobile" + str;
      }
      return str;
    },

    video_src() {
      return (
        "static/content/" +
        this.selected_section +
        "/" +
        this.selected_sub_section +
        "/pdf/" +
        this.item.filename +
        "." +
        (this.item.has_mp4 ? "mp4" : "webm")
      );
    },
    video_popup_class() {
      return "internal-image " + this.loading;
    },

    img_style() {
      let style = {};

      if ("undefined" != typeof this.item.style) {
        style = this.item.style;
      }
      return style;
    },
    img_src() {
      return (
        "static/content/" +
        this.selected_section +
        "/" +
        this.selected_sub_section +
        "/" +
        this.item.src
      );
    },
    link_src() {
      return this.item.link;
    },
    has_link() {
      return "undefined" != typeof this.item.link && this.item.link.length > 0;
    },
    selected_section() {
      if (this.current_secondary_section != "") {
        return this.current_secondary_section;
      }
      return this.current_section;
    },
    selected_sub_section() {
      if (this.current_secondary_sub_section != "") {
        return this.current_secondary_sub_section;
      }
      return this.current_sub_section;
    }
  },
  methods: {
    close_subpopup(e) {
      this.$bus.$emit("on-request-subpopup-close");
    },
    prevent_close(e) {
      e.stopPropagation();
    }
  }
};
</script>

<style scoped>
.loading-app {
  display: none;
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  transform: translateY(-50%);
}
.loading .loading-app {
  display: block;
}
.scroll-helper {
  text-align: center;
}
.scroll-helper img {
  display: inline-block;
  max-height: 90vh;
}

.app-popup-instructions {
  background: rgba(20, 20, 20, 0.8);
  text-transform: uppercase;
}

.option-bar {
  position: absolute;
  top: 9px;
  right: -30px;
  width: 38px;
  height: 38px;
}
.close-link {
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  display: inline-block;
  background: url("../../assets/close.png") 0 0 no-repeat;
  background-size: cover;
  width: 40px;
  height: 40px;
  overflow: hidden;
  text-align: left;
  text-indent: -1000px;
  cursor: pointer;
}

@media only screen and (max-width: 1110px) {
  .option-bar {
    top: 0px;
    right: 0;
  }
}
@media only screen and (max-width: 1110px) and (max-height: 460px) {
  .option-bar {
    top: 5px !important;
    right: 5px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subpopups/face.vue